module.exports = __webpack_public_path__ + "static/media/steamerIcon.c589de9a.svg";